import renderCaptchaComponent, { createCaptchaComponent } from '../../components/turnstile/Captcha';

document.addEventListener('DOMContentLoaded', renderCaptchaComponent);
document.addEventListener('rerender-captcha', renderCaptchaComponent);

document.addEventListener('render-captcha', (event: Event) => {
    if (!(event instanceof CustomEvent)) {
        return;
    }

    createCaptchaComponent(event.detail.input, event.detail.options, event.detail.ref);
});
